import { Login } from '../../components/loginPage/Login';

export const LoginPage = () => {
  return <Login />;
};
